import { belongsTo, attr } from '@ember-data/model';
import ShModel from './sh-model';
import { computed } from '@ember/object';

const CHANNEL_TYPES = {
  EMAIL: 'email',
  DEVICE: 'device',
};

const NOTIFICATION_TYPES = {
  JOB_OPPORTUNITIES: 'job_opportunities',
  MESSAGES: 'messages',
  PROJECT_UPDATES: 'project_updates',
};

const STATUSES = {
  ON: 1,
  OFF: 0,
};

export const NOTIFICATION_PREFERENCE = {
  CHANNEL_TYPES,
  NOTIFICATION_TYPES,
  STATUSES,
};

const NotificationPreference = ShModel.extend({
  notificationType: attr('string'),
  status: attr('number'),
  channel: attr('string'),
  channelId: attr('string'),
  startAt: attr('date'),
  endAt: attr('date'),
  device: belongsTo('userDevice', { async: false }),
  user: belongsTo('user', { async: false }),

  isEmailChannel: computed('channel', function() {
    return this.get('channel') === NOTIFICATION_PREFERENCE.CHANNEL_TYPES.EMAIL;
  }),

  isDeviceChannel: computed('channel', function() {
    return this.get('channel') === NOTIFICATION_PREFERENCE.CHANNEL_TYPES.DEVICE;
  }),

  isJobOpportunitiesNotificationType: computed('notificationType', function() {
    return this.get('notificationType') === NOTIFICATION_PREFERENCE.NOTIFICATION_TYPES.JOB_OPPORTUNITIES;
  }),

  isMessagesNotificationType: computed('notificationType', function() {
    return this.get('notificationType') === NOTIFICATION_PREFERENCE.NOTIFICATION_TYPES.MESSAGES;
  }),

  isProjectUpdatesNotificationType: computed('notificationType', function() {
    return this.get('notificationType') === NOTIFICATION_PREFERENCE.NOTIFICATION_TYPES.PROJECT_UPDATES;
  }),

  /**
   * True if we have a start and end date for this preference
   *
   * @return {boolean}
   */
  isTimed: computed('startAt', 'endAt', function() {
    return !!this.get('startAt') && !!this.get('endAt');
  }),

  /**
   * Return true if we have a start and an end date, and the preference and we're before the just the end date.
   *
   * @return {boolean}
   */
  isWithinTimeframe: computed('startAt', 'endAt', function() {
    let startAt = this.get('startAt'),
      endAt = this.get('endAt');

    if (!startAt || !endAt) {
      return false;
    }

    let now = new Date();
    now.setHours(0,0,0,0);
    return now <= endAt;
  }),

  /**
   * True if this status is ON, this will take into account if a preference is timed or not
   *
   * @return {boolean}
   */
  isStatusOn: computed('status', 'isWithinTimeframe', 'isTimed', function() {
    if (this.get('status') === NOTIFICATION_PREFERENCE.STATUSES.OFF && this.get('isTimed')) {
      return !this.get('isWithinTimeframe');
    }

    return this.get('status');
  }),

  /**
   * True if this status is OFF, this will take into account if a preference is timed or not
   *
   * @return {boolean}
   */
  isStatusOff: computed('status', 'isWithinTimeframe', 'isTimed', function() {
    if (this.get('isTimed')) {
      return this.get('status') === NOTIFICATION_PREFERENCE.STATUSES.OFF && this.get('isWithinTimeframe');
    }

    return this.get('status') === NOTIFICATION_PREFERENCE.STATUSES.OFF;
  })
});

export default NotificationPreference;
